import { render, staticRenderFns } from "./V2FileUpload.vue?vue&type=template&id=67e7922e&scoped=true&"
import script from "./V2FileUpload.vue?vue&type=script&lang=js&"
export * from "./V2FileUpload.vue?vue&type=script&lang=js&"
import style0 from "./V2FileUpload.vue?vue&type=style&index=0&id=67e7922e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e7922e",
  null
  
)

export default component.exports